<template>
  <section>
    <!-- 用户信息展示区域 -->
    <el-card class="user-info-card">
      <div class="user-info-container">
        <div class="user-details">
          <div class="user-name">
            {{ userInfo.WxUserInfoName || "未知用户" }}
            <!-- <span v-if="userInfo.gender">{{ userInfo.gender }}</span>
            <el-tag size="mini" v-if="userInfo.level">{{
              userInfo.level
            }}</el-tag> -->
          </div>
          <div class="user-info-row">
            <div class="info-item">
              <span class="label">会员名称：</span>
              <span class="value">{{ userInfo.UserName || "--" }}</span>
            </div>
            <div class="info-item">
              <span class="label">电话：</span>
              <span class="value">{{ userInfo.TelPhone || "--" }}</span>
            </div>
          </div>
          <div class="user-info-row">
            <div class="info-item">
              <span class="label">证件：</span>
              <span class="value">{{ userInfo.idCard || "--" }}</span>
            </div>
            <div class="info-item">
              <span class="label">住址：</span>
              <span class="value">{{ userInfo.address || "--" }}</span>
            </div>
          </div>
          <div class="user-info-row">
            <div class="info-item">
              <span class="label">备注：</span>
              <span class="value">{{ userInfo.remark || "--" }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 标签页区域 -->
    <el-tabs v-model="activeTab" class="record-tabs">
      <el-tab-pane
        v-for="(item, index) in activeTabsOptions"
        :label="item.label"
        :name="item.name"
        :key="'activeTabsOptions_' + index"
      >
        <component
          :is="item.component"
          :WxUserInfoId="WxUserInfoId"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
import CardDetails from "./components/cardDetails.vue";
import RechargeRecord from "./components/rechargeRecord.vue";
import VerificationRecord from "./components/verificationRecord.vue";
export default {
  name: "MemberAccountBook",
  components: {
    CardDetails,
    RechargeRecord,
    VerificationRecord,
  },
  data() {
    return {
      // 用户信息
      userInfo: {},
      // 当前激活的标签页
      activeTab: "cardDetails",
      activeTabsOptions: [
        {
          label: "持卡详情",
          name: "cardDetails",
          component: CardDetails,
        },
        {
          label: "充值记录",
          name: "rechargeRecord",
          component: RechargeRecord,
        },
        {
          label: "核销记录",
          name: "verificationRecord",
          component: VerificationRecord,
        },
      ],
      // 会员ID
      WxUserInfoId: "",
    };
  },
  created() {
    // 从路由参数获取会员ID
    console.log("params", this.$route.params.userInfo);
    this.userInfo = this.$route.params.userInfo;
    this.WxUserInfoId = this.$route.params.userInfo.WxUserInfoId;
  },
  methods: {},
};
</script>

<style scoped>
.user-info-card {
  margin-bottom: 20px;
}

.user-info-container {
  display: flex;
}

.user-avatar {
  width: 120px;
  height: 120px;
  margin-right: 20px;
}

.avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: cover;
}

.user-details {
  flex: 1;
}

.user-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.user-info-row {
  display: flex;
  margin-bottom: 8px;
}

.info-item {
  width: 50%;
  display: flex;
}

.label {
  color: #606266;
  width: 100px;
  text-align: justify;
}

.value {
  color: #303133;
  flex: 1;
}

.record-tabs {
  margin-bottom: 20px;
}
</style>
